import type { SORT_MAP } from 'utils/sort/types'

export const useIsPinningActive = (sortId: keyof SORT_MAP): boolean =>
  sortId !== 'random-sort'
